document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('#commentform');
    const warning = document.getElementById('comment-warning');

    if (form) {
        form.addEventListener('submit', function (event) {
            let isValid = true;
            warning.style.display = 'none';

            // Check each required field
            form.querySelectorAll('input[required], textarea[required]').forEach(function (field) {
                const fieldContainer = field.closest('.comments-user-fields, .comments-reply-field');
                if (field.value.trim() === '') {
                    isValid = false;
                    fieldContainer.classList.add('field_not_filled');
                } else {
                    fieldContainer.classList.remove('field_not_filled');
                }
            });

            // Check comment length
            const commentField = form.querySelector('#comment');
            if (commentField && commentField.value.trim().length > 1500) {
                isValid = false;
            }

            if (!isValid) {
                event.preventDefault(); // Prevent form submission
                warning.style.display = 'flex'; // Show warning message
            }
        });
    }
});

jQuery(document).ready(function () {
    function toggleComments() {
        var commentsSection = document.getElementById('comments');
        var toggleButton = document.getElementById('comments-toggle');

        if (commentsSection.style.display === 'none') {
            commentsSection.style.display = 'block';
            toggleButton.classList.add('open');
            toggleButton.classList.remove('close');
        } else {
            commentsSection.style.display = 'none';
            toggleButton.classList.add('close');
            toggleButton.classList.remove('open');
        }
    }

    // Add event listeners for click and keydown
    var toggleButton = document.getElementById('comments-toggle');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleComments);
        toggleButton.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                toggleComments();
            }
        });
    }

    // Add event listener for anchor-comments
    var anchorComments = document.getElementById('anchor-comments');
    if (anchorComments) {
        anchorComments.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default anchor behavior
        toggleButton.scrollIntoView({ behavior: 'smooth' }); // Scroll to comments-toggle
            toggleComments(); // Toggle comments
        });

        anchorComments.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default anchor behavior
            toggleButton.scrollIntoView({ behavior: 'smooth' }); // Scroll to comments-toggle
            toggleComments(); // Toggle comments
            toggleButton.focus(); // Move focus to comments-toggle
            }
        });
    }


    ///content middle ad
    // Select the element by class after it's added to the DOM
    const adElement = document.querySelector('.sponsored_content_ad');
    if (adElement) {
        const adElementHTML = adElement.innerHTML;

        // Select the content container
        const contentContainer = document.querySelector('.single__content .content');

        // Find the middle element of the content container
        const paragraphs = contentContainer.querySelectorAll('p');
        const middleIndex = Math.floor(paragraphs.length / 2);

        // Insert the ad element at the middle position
        paragraphs[middleIndex].insertAdjacentElement('afterend', adElement);
    }
});

jQuery('.comment .reply').on('click', function (e) {
    e.preventDefault()

    let parent = jQuery(this).closest('.depth-1')

    if (parent.length > 0) {

        let replyToComment = jQuery(this).closest('.comment')

        let id = replyToComment.attr('id')
        id = id.replace('comment-', '')

        // add hidden input with comment we are replying to
        jQuery('<input>').attr('type', 'hidden').attr('name', 'comment_parent').attr('value', id).appendTo('.comments-reply form')

        // add name of person we're replying to
        jQuery('.comments-reply .comments-reply__name').text('')
        jQuery('.comments-reply .comments-reply__name').text(jQuery('#' + replyToComment.attr('id') + ' .comment-author.vcard').first().text())

        // add form to the end of the current comment thread and display it
        jQuery('.comments-reply').appendTo(parent).show()

    }
})

jQuery('.comments-reply .comments-reply__cancel').on('click', function () {

    jQuery('.comments-reply').hide()

})


